import { render, staticRenderFns } from "./CardProfile.vue?vue&type=template&id=3330cfa8"
import script from "./CardProfile.vue?vue&type=script&lang=js"
export * from "./CardProfile.vue?vue&type=script&lang=js"
import style0 from "./CardProfile.vue?vue&type=style&index=0&id=3330cfa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports